import { render, staticRenderFns } from "./ContratoModeloSocinal.vue?vue&type=template&id=609d51bc&scoped=true&"
import script from "./ContratoModeloSocinal.vue?vue&type=script&lang=js&"
export * from "./ContratoModeloSocinal.vue?vue&type=script&lang=js&"
import style0 from "./ContratoModeloSocinal.vue?vue&type=style&index=0&id=609d51bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d51bc",
  null
  
)

export default component.exports